var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 28,
    height: 28,
    role: "img",
    "aria-label": "Shield with user icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,12.4C14.1,12.4 15.8,13.5 16.8,15C15.8,16.5 14.1,17.6 12,17.6C9.9,17.6 8.2,16.5 7.2,15C8.2,13.5 9.9,12.4 12,12.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskShieldIcon);
export default __webpack_public_path__ + "static/media/risk-shield-icon.9aed6d5ad920257dc593da40e3a7c2c1.svg";
export { ForwardRef as ReactComponent };